import { ITopicList } from "@/api/topics";
import { LinkRouter } from "@/components/shared/buttons/LinkRouter";

interface IProps {
    topic: ITopicList;
}

export const TopicNameLink = ({ topic }: IProps) => {
    return (
        <LinkRouter to={`/admin/topics/${topic.id}/details`} noWrap>
            {topic.name}
        </LinkRouter>
    );
};
